import { render, staticRenderFns } from "./studentManage.vue?vue&type=template&id=44ffc850&scoped=true&"
import script from "./studentManage.vue?vue&type=script&lang=js&"
export * from "./studentManage.vue?vue&type=script&lang=js&"
import style0 from "./studentManage.vue?vue&type=style&index=0&id=44ffc850&scoped=true&lang=scss&"
import style1 from "./studentManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ffc850",
  null
  
)

export default component.exports